// extracted by mini-css-extract-plugin
export default {"modalContainer":"ViewMemberPagesModal_modalContainer__2iiR1"};